import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6e35ac4&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c6e35ac4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e35ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6e35ac4')) {
      api.createRecord('c6e35ac4', component.options)
    } else {
      api.reload('c6e35ac4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6e35ac4&scoped=true&lang=pug", function () {
      api.rerender('c6e35ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/thankYou/anniversary2023/index.vue"
export default component.exports